import { configureStore } from '@reduxjs/toolkit';
import productsReducer from '../features/products/productsSlice';
import usersReducer from '../features/users/usersSlice';
import authReducer from '../features/auth/authSlice';
import { apiSlice } from './apiSlice';

const store = configureStore({
  reducer: {
    products: productsReducer,
    users: usersReducer,
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
